import { ForecastParemeterProductTypeBase } from './base/forecast-paremeter-product-type-base';

export class ForecastParemeterProductType extends ForecastParemeterProductTypeBase { }